import { render, staticRenderFns } from "./mapBlock.vue?vue&type=template&id=53fa7de8&"
import script from "./mapBlock.vue?vue&type=script&lang=js&"
export * from "./mapBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports